import { call, put, select, takeLatest } from "redux-saga/effects";
import {
  operationFailed,
  sendOfferEmail,
  sendOfferEmailSucceeded,
} from "./slice";

import { cartSelector } from "Store/cart/cartSagas";
import { getErrorMessage } from "Utils/errorUtils";
import { createRequest } from "Utils/requestUtils";
import { Cart } from "../cart/cartInterfaces";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function* sendOfferEmailRequest({
  payload,
}: ReturnType<typeof sendOfferEmail>) {
  const cartFromState: Cart | null = yield select(cartSelector);
  if (!cartFromState) {
    throw new Error("No cart!");
  }
  const url = `/open/insurance/carts/${cartFromState.cartId}/save`;

  try {
    yield call(createRequest, {
      method: "post",
      requestBody: payload,
      url,
    });
    yield put(sendOfferEmailSucceeded());
  } catch (e) {
    yield put(
      operationFailed(getErrorMessage(e, "Failed to send offer email")),
    );
  }
}

export function* offerSaga(): Generator {
  yield takeLatest(sendOfferEmail, sendOfferEmailRequest);
}
